import io from 'socket.io-client';

let socket;
let auth = {};

export const setupSocket = (url, opts = {}, cb) => {
  const defaultOpts = opts || { withCredentials: true };
  socket = io(url, defaultOpts);
  socket.on('connect', (s) => {
    console.log('WS Connected!');
    if (cb) cb(socket);
  });
};

export const socketOn = (msg, cb) => {
  socket?.off(msg);
  socket?.on(msg, cb);
};

export const enterGame = (data, cb) => {
  socket.emit('enter', data, (gameData) => {
    auth = data;
    cb(gameData);
  });
};

export const enterBackend = (data, cb) => {
  socket.emit('enter-backend', data, (gameData) => {
    auth = data;
    cb(gameData);
  });
};
